import { compile } from 'path-to-regexp'
import { isValidURL } from '@/utilities/url'
import { UrlUtil } from '@/utilities/url'

/**
 * @param {string} url
 * @param {?Object} params
 *
 * @return {string}
 */
export function toPath(url: string, params: Record<string, string>) {
  if (!url) return ''
  if (!params) return url

  return compile(url)(params)
}

/**
 * 引数に渡されたパス文字列にクエリパラメータを付与する
 *
 * @param path ベースとなるパス文字列（絶対パス、相対パスどちでも可）
 * @param params 付与するクエリパラメータ（単一オブジェクト、または配列）
 * @returns string 生成したクエリパラメータ付きパス文字列
 */
export function pathWithQueryParams(path: string, params?: QueryParameter | QueryParameter[]): string {
  if (!path) return ''
  if (!params) return path

  try {
    const isURL = isValidURL(path)
    const baseUrl = new URL(window.location.href).origin
    const url = isURL
      ? new URL(path)
      : new URL(path, baseUrl)

    if (Array.isArray(params)) {
      params?.forEach(v => {
        if (!v.name) return
        url.searchParams.set(v.name, v.value.toString())
      })
    } else if (params.name) {
      url.searchParams.set(params.name, params.value.toString())
    }

    return isURL
      ? url.toString()
      : url.toString().replace(baseUrl, '')
  } catch(e) {
    console.error('invalid path string.')
    return path || ''
  }
}

/**
 * 引数に渡されたパス文字列が現在のページかどうかを判定する
 *
 * @param path ベースとなるパス文字列（絶対パス、相対パスどちでも可）
 * @param queryKeys 一致条件対象のクエリパラメータの key 名配列（この配列で指定されたクエリ key に対する value が一致しているかどうかを走査する）
 * @returns boolean
 */
export function isCurrentPage(path: string, queryKeys?: string[]): boolean {
  if (!path) return false

  try {
    const isURL = isValidURL(path)
    const baseUrl = new URL(window.location.href)
    const target = new UrlUtil(isURL
      ? path
      : new URL(path, baseUrl.origin).href
    )
    const current = new UrlUtil()

    return  target.getUrlStringWithoutQuery() === current.getUrlStringWithoutQuery() &&
            (!queryKeys || queryKeys?.every(v => target.getQueryParameter(v) === current.getQueryParameter(v)))
  } catch(e) {
    console.error('invalid path string.')
    return false
  }
}
